var React = require('react');

function Dev (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Stratumn Developers"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",null,[React.createElement("path",{"d":"M13.33,8.33h-.88v7h.88a1.92,1.92,0,0,0,1.52-.51,2.42,2.42,0,0,0,.43-1.59v-3a2.07,2.07,0,0,0-.43-1.43A2,2,0,0,0,13.33,8.33Z","fill":"#4b35d2","key":0}),React.createElement("path",{"d":"M47.06,0H2.31A2.32,2.32,0,0,0,0,2.31V21.39A2.32,2.32,0,0,0,2.31,23.7H47.06a2.32,2.32,0,0,0,2.32-2.31V2.31A2.32,2.32,0,0,0,47.06,0ZM17.36,13.45a3.91,3.91,0,0,1-1,2.95,4.23,4.23,0,0,1-3,1h-4v-2h1v-7h-1v-2h4a4.28,4.28,0,0,1,3,1,3.94,3.94,0,0,1,1,3Zm10.09,3.9H20.31v-11h7v2H22.38v2.52h4.69v2H22.38v2.54h5.07Zm8.73,0H32.29l-2.49-11h2.14l2.15,10h.29l2.15-10h2.14Z","fill":"#4b35d2","key":1})])))]);
}

Dev.defaultProps = {"viewBox":"0 0 49.38 23.7"};

module.exports = Dev;

Dev.default = Dev;
